module.exports = __webpack_public_path__ + "img/family.3f98297f.svg";